var map = {
	"./sidebar_1.jpg": 22599,
	"./sidebar_2.jpg": 52430,
	"./sidebar_3.jpg": 45772,
	"./sidebar_4.jpg": 5826,
	"./sidebar_5.jpg": 28938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78552;